
import { Component, Input, OnInit, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DataContextService } from '../../../core/services/data-context.service';
import { WindowService } from '../../../core/services/window.service';
import { GlobeService } from '../../../core/services/globe.service';
import { DeviceService } from '../../../core/services/device.service'; // Adjust path as needed
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-user-cluster-list-ui',
  standalone: true,
  imports: [],
  templateUrl: './user-cluster-list-ui.component.html',
  styleUrl: './user-cluster-list-ui.component.css'
})
@Injectable()
export class UserClusterListUiComponent implements OnInit, OnChanges {
  @Input() dataIsCluster!: boolean;
  @Input() data: any;
  @Input() statuses: string[] = [];
  @Input() floorPerimeterId: any;
  @Input() floorType: string = '';
  @Input() userData: any[] = [];
  @Input() incidentId: string = '';
  @Input() lat: number | undefined;
  @Input() lon: number | undefined;
  @Input() clusterSize: number | undefined;
  @Input() timestamp: string | undefined;
  @Input() enablePlayback: boolean = false;
  @Input() incident: any; // Pass the incident object as an input

  page: number = 1;
  limit: number = 15;
  totalUserCount: number = 0;
  lastPage: number = 1;
  users: any[] = [];
entity: any;
  constructor(
    public activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef,
    private dataContext: DataContextService,
    private windowService: WindowService,
    private globeService: GlobeService,
    private deviceService: DeviceService // Inject DeviceService
  ) {}

  ngOnInit() {
     const event = this.dataContext.getMapEntity(this.entity?.id) ||
              this.dataContext.getMapEntity(this.entity?.id);
const incident = event ? event.arcLiveMapEntity : this.entity;
    this.setupUsers();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['userData'] || changes['dataIsCluster'] || changes['statuses'] || changes['clusterSize']) {
      if (changes['userData']) {
      }
      if (changes['statuses']) {
      }
      if (changes['clusterSize']) {
      }
      this.setupUsers();
      this.cdr.markForCheck();
    }
  }

  setupUsers() {
    this.userData = this.userData || [];
    this.page = 1;
    this.userData.forEach(user => {
      user.visible = !!user.visible;
      user.src = this.getUserIcon(user);
    });
    this.totalUserCount = this.userData.length;
    this.lastPage = Math.max(1, Math.ceil(this.totalUserCount / this.limit));
    this.jumpPage(0);
    this.cdr.markForCheck();
  }

  jumpPage(n: number) {
    this.page = Math.max(1, Math.min(this.page + n, this.lastPage));
    const i1 = (this.page - 1) * this.limit;
    const i2 = i1 + this.limit;
    this.users = this.userData.slice(i1, i2);
  }

  getUserIcon(user: any): string {
    if (user.name?.toLowerCase().includes('suspect')) {
      return 'assets/img/arcangel/user_suspect.svg';
    }
    switch ((user.status || '').toLowerCase()) {
      case 'danger': return 'assets/img/arcangel/user_in_danger.svg';
      case 'safe': return 'assets/img/arcangel/user_safe.svg';
      case 'suspect': return 'assets/img/arcangel/unknown_gray.png';
      default: return 'assets/img/arcangel/user_unknown.svg';
    }
  }

  toggleUserVisibility(user: any) {
    if (user.visible) {
      this.removeUser(user);
    } else {
      this.showUser(user);
    }
    user.visible = !user.visible;
  }
  
  showUser(user: any) {
   const incident = this.entity;
    if (!incident) return;
    const entity = this.dataContext.getDevicemapEntityByDeviceId(user.deviceId);
    if (!entity) {
      let time;
      // If playback, set time as needed
      if (this.enablePlayback) {
        // let timestamp = Math.floor(this.coreService.getCurrentTime() / 1000) * 1000;
        // time = moment(timestamp).toISOString();
      }
      this.createIncidentDeviceMapEntity(user, incident, time);
      return;
    }
  }

  showUserInfo(user: any) {
    const entity = this.getDeviceMapEntityById(user.deviceId)
      || this.dataContext.getDevicemapEntityByDeviceId(user.deviceId);

    if (entity) {
      this.showUsersInfoInWindow(entity);
    } else {
      const incident = this.incident || this.entity;
      if (!incident) return;
      this.deviceService.getIncidentDeviceDataByDeviceId(user, incident).subscribe({
        next: () => {
          setTimeout(() => {
            const newEntity = this.getDeviceMapEntityById(user.deviceId)
              || this.dataContext.getDevicemapEntityByDeviceId(user.deviceId);
            if (newEntity) {
              this.showUsersInfoInWindow(newEntity);
            }
          }, 100);
        },
        error: (err) => {
          console.error('Error fetching device data for user info window:', err);
        }
      });
    }
  }
  getDeviceMapEntityById(deviceId: string): any {
    if (this.entity?.devices?.[deviceId]) {
      return this.entity?.devices?.[deviceId];
    } else if (this.entity?.building?.incidents?.[0]?.devices?.[deviceId]) {
      return this.entity.building.incidents[0].devices[deviceId];
    } else if (this.incident?.devices?.[deviceId]) {
      return this.incident?.devices?.[deviceId];
    }
    return undefined;
  }
  removeUser(user: any) {
    const entity = this.dataContext.getDevicemapEntityByDeviceId(user.deviceId);
    if (entity) {
    }
  }

  showUsersInfoInWindow(entity: any) {
    // Check if the details window for this entity is already open
    if (!this.windowService.isEntityDetailsWindowOpen(entity.getWindowId())) {
      // Open the details window (or handle click logic)
      this.globeService.handleClick(this, entity);
    }
  }

  createIncidentDeviceMapEntity(user: any, incident: any, time?: string): void {
    let api$: Observable<any>;
    if (this.enablePlayback) {
      // api$ = this.deviceService.getIncidentDeviceHistoryDataByDeviceId(user, incident, time);
       api$ = this.deviceService.getIncidentDeviceDataByDeviceId(user, incident);
    } else {
      api$ = this.deviceService.getIncidentDeviceDataByDeviceId(user, incident);
    }
    api$.subscribe({
      next: () => {
        // Device entity created/updated
      },
      error: (error) => {
        console.error('Error creating/updating device map entity:', error);
      }
    });
  }
}